<template>
  <div class="footer">
    <div class="nav">
      <div v-for="(item,index) in navList" :key="index" class="nav_content">
        <div class="name" @click="ohter(item.lable.length!=0?item.lable[0]:item.name)">{{ item.name }}</div>
        <div class="lable" v-for="(items,indexs) in item.lable" :key="indexs" @click="jump(item,items)">{{ items.name }}</div>
      </div>
    </div>
    <div class="weixin">
      <img src="./../assets/home/weixin.png" alt="">
      <div class="triangle"></div>
    </div>
    <div class="cop">Copyright © 2019-{{ Year }} 湖南兆物信链科技集团有限公司 版权所有 <a style="color: #dbdbdb;text-decoration: none"
                                                                        href="https://beian.miit.gov.cn/"
                                                                        target="_blank">湘ICP备19019059号</a>&nbsp;
      <a style="color: #dbdbdb;text-decoration: none" href="http://www.beian.gov.cn/portal/registerSystemInfo"target="_blank">湘公网安备 43010502001004号</a>
      <div class="tel">联系电话：0731-85584896</div>

      <span>微信公众号</span></div>

  </div>
</template>

<script>
export default {
  name: "mian-footer",
  data() {
    return {
      Year: new Date().getFullYear(),
      navList: [
        {
          name: '可信数据空间产品',
          lable: [
            {
              name: '数据安全产品',
              id:"590",
              text:'兆安-全链路数据安全智能防护平台'
            },
            {
              name: '区块链产品',
              id:"411",
              text:'国产高性能自主可控联盟链MT'
            },
            {
              name: '区块链解决方案',
              id:"152",
              text:'兆票',
            },
            {
              name: '隐私计算产品',
              id:"515",
              text:'兆隐-国产区块链多方安全隐私计算联邦学习平台',
            },
            {
              name: '零信任产品',
              id:"517",
              text:'兆零-零信任基础平台及统一认证门户',
            }
          ]
        }, {
          name: '异构无人集群及智能传感器系列产品',
          lable: [
            {
              name: '异构无人集群产品',
              id:"416",
              text:'兆群-异构无人集群系统自主多域作战弹性指控平台',
            },
            {
              name: '智能传感器无人值守产品',
              id:"440",
              text:'兆感：空天地海潜一体柔性复合防御无人值守集群平台'
            },
            // {
            //   name: '指挥保障运维产品',
            //   id:"442",
            //   text:'兆维：保障仿真筹划管控运维系统产品'
            // }
          ]
        },
        {
          name: '区块链产品演示',
          lable: []
        },
        {
          name: '新闻动态',
          lable: []
        }, {
          name: '关于我们',
          lable: []
        }, {
          name: '加入我们',
          lable: []
        }
      ]

     /* navList: [
        {
          name: '可信数据空间产品',
          lable: [
            {
              name: '区块链产品',
              id:"411",
              text:'兆链：国产自主可控联盟链基础设施产品'
            },
            {
              name: '区块链解决方案',
              id:"152",
              text:'兆票',
            }
          ]
        }, {
          name: '异构无人集群及智能传感器系列产品',
          lable: [
            {
              name: '异构无人集群产品',
              id:"416",
              text:'兆群-异构无人集群系统自主多域作战弹性指控平台',
            },
            {
              name: '智能传感器无人值守产品',
              id:"440",
              text:'兆感：空天地海潜一体柔性复合防御无人值守集群平台'
            },
            // {
            //   name: '指挥保障运维产品',
            //   id:"442",
            //   text:'兆维：保障仿真筹划管控运维系统产品'
            // }
          ]
        },
        {
          name: '新闻动态',
          lable: []
        }, {
          name: '关于我们',
          lable: []
        }, {
          name: '加入我们',
          lable: []
        }
      ]*/
    }
  },
  methods:{
    ohter(items){
      console.log(items)
      if (items == "新闻动态"){
        this.$router.push({
          name: 'news'
        })
      }else if (items == "关于我们"){
        this.$router.push({
          name: 'about',
          query: {
            time: new Date().getTime()
          }
        })
      }else if (items == "加入我们"){
        this.$router.push({
          name: 'recruitment'
        })
      }else {
        this.$router.push({
          name: 'scheme',
          query: {
            item: items.name,
            text: items.text,
            id: items.id,
            time: new Date().getTime()
          }
        })
      }
    },
    jump(item,items) {

      this.$router.push({
        name: 'scheme',
        query: {
          item: items.name,
          text: items.text,
          id: items.id,
          time: new Date().getTime()
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  position: relative;
  bottom: 0px;
  background-color: #282B31;
  .nav {
    margin: 0 auto;
    max-width: 1280px;
    height: 320px;
    display: flex;
    /*bottom: 38px;*/
    .nav_content {
      width: 20%;
      text-align: left;
      height: 70%;
      padding: 50px 30px 0 30px;
      /*border-right: 1px solid #33363c;*/
      .name {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 24px;
        padding-bottom: 20px;
      }

      .lable {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #606673;
        line-height: 20px;
        cursor: pointer;
      }
    }
  }

  .weixin {
    position: absolute;
    bottom: 38px;
    right: 38px;

    img {
      width: 74px;
      height: 74px;
      margin-bottom: -5px;
    }

    .triangle {
      width: 0;
      height: 0;
      border-top: 10px solid white;
      border-right: 10px solid transparent;
      border-left: 10px solid transparent;
      margin: 0 auto;
    }
  }

  .cop {
    background-color: #066DFF;
    height: 38px;
    width: 100%;
    position: relative;
    text-align: center;
    line-height: 38px;
    color: #dbdbdb;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;

    span {
      float: right;
      width: 150px;
      height: 38px;
      background: #0E64E0;
    }
    .tel{
      position: absolute;
      right: 170px;
      bottom: 0;
    }
  }
}
</style>
